import { render, staticRenderFns } from "./newgateway.vue?vue&type=template&id=10d6f29a&scoped=true"
import script from "./newgateway.vue?vue&type=script&lang=js"
export * from "./newgateway.vue?vue&type=script&lang=js"
import style0 from "./newgateway.vue?vue&type=style&index=0&id=10d6f29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6f29a",
  null
  
)

export default component.exports